import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';
import { buildContracts } from './helpers';
import { IContracts, ICustomerContracts, ITermsContracts } from './types';

export const getContractsActions = createActionCreators<
	{ T: 'CUSTOMER_CONTRACTS_REQUEST' },
	{ T: 'CUSTOMER_CONTRACTS_RECEIVE', P: ICustomerContracts },
	{ T: 'CUSTOMER_CONTRACTS_FAILURE', P: { error: Error } }
	>('CUSTOMER_CONTRACTS_REQUEST', 'CUSTOMER_CONTRACTS_RECEIVE', 'CUSTOMER_CONTRACTS_FAILURE');

export const getCustomerContracts = (customerId: string): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(getContractsActions.CUSTOMER_CONTRACTS_REQUEST());
	try {
		const contracts = await api.contracts.getChannelsForCustomer(customerId) || {} as IContracts;
		const customerContract = { id: customerId, contracts } as ICustomerContracts;
		dispatch(getContractsActions.CUSTOMER_CONTRACTS_RECEIVE(customerContract));
	} catch (error) {
		dispatch(getContractsActions.CUSTOMER_CONTRACTS_FAILURE({ error }));
		throw error;
	}
};

export const updateContractActions = createActionCreators<
	{ T: 'UPDATE_CONTRACTS_REQUEST' },
	{ T: 'UPDATE_CONTRACTS_RECEIVE', P: ICustomerContracts },
	{ T: 'UPDATE_CONTRACTS_FAILURE', P: { error: Error } }
	>('UPDATE_CONTRACTS_REQUEST', 'UPDATE_CONTRACTS_RECEIVE', 'UPDATE_CONTRACTS_FAILURE');

export const updateByCustomer = (customerId: string, contracts: IContracts): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(updateContractActions.UPDATE_CONTRACTS_REQUEST());
	try {
		const contractsRaw = await api.contracts.updateChannelsForCustomer(customerId, contracts);
		const customerContract = { id: customerId, contracts: buildContracts(contractsRaw) } as ICustomerContracts;
		dispatch(updateContractActions.UPDATE_CONTRACTS_RECEIVE(customerContract));
	} catch (error) {
		dispatch(updateContractActions.UPDATE_CONTRACTS_FAILURE({ error }));
	}
};

export const updateTermsActions = createActionCreators<
	{ T: 'UPDATE_TERMS_REQUEST' },
	{ T: 'UPDATE_TERMS_RECEIVE', P: ITermsContracts },
	{ T: 'UPDATE_TERMS_FAILURE', P: { error: Error } },
	{ T: 'GET_TERMS_RECEIVE', P: ITermsContracts }
	>('UPDATE_TERMS_REQUEST', 'UPDATE_TERMS_RECEIVE', 'UPDATE_TERMS_FAILURE', 'GET_TERMS_RECEIVE');

export const updateCustomerTerms = (customerId: string, contracts: IContracts): ThunkAction =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(updateTermsActions.UPDATE_TERMS_REQUEST());
		try {
			const contractsRaw = await api.contracts.updateTermsForCustomer(customerId, contracts);
			const customerContract = { id: customerId, contracts: buildContracts(contractsRaw) } as ITermsContracts;
			dispatch(updateTermsActions.UPDATE_TERMS_RECEIVE(customerContract));
		} catch (error) {
			dispatch(updateTermsActions.UPDATE_TERMS_FAILURE({ error }));
		}
	};

export const getCustomerTerms = (customerId: string): ThunkAction => async (dispatch, getState, { _deprecatedApi: api }) => {
	try {
		const termsContractRaw = await api.contracts.getTermsForCustomer(customerId);
		const termsContracts = { id: customerId, contracts: termsContractRaw };
		dispatch(updateTermsActions.GET_TERMS_RECEIVE(termsContracts));
	} catch (error) {
		dispatch(updateTermsActions.UPDATE_TERMS_FAILURE({ error }));
	}
};

const actions = { ...getContractsActions, ...updateContractActions, ...updateTermsActions };

type ContractsActions = ActionValues<typeof actions>;
type ContractsActionsTypes = ActionTypeNames<ContractsActions>;

export type Actions = ContractsActions[keyof ContractsActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as ContractsActionsTypes);
